import moment from 'moment-timezone';

import { createApi } from './core';
import { Config, Log, LogWithData, Subscriber } from './webhooks.types';

declare const healConfig: any;

function createWebhooksApi(hideMessage = false) {
  return createApi({ baseURL: healConfig.apiBaseUrl + '/webhooks', hideMessage });
}

export function fetchWebhookSubscribers(): Promise<Record<string, Subscriber>> {
  return createWebhooksApi()
    .then((api) => api.get<any>('/subscribers'))
    .then((r) => (r.ok ? r.data.data : null));
}

export function fetchWebhookConfig(subscriberId: string): Promise<Config> {
  return createWebhooksApi()
    .then((api) => api.get<any>(`/${subscriberId}/config`))
    .then((r) => (r.ok ? r.data.data : null));
}

export function fetchWebhookLogs(subscriberId: string, date: string): Promise<Log[]> {
  const from = moment(date).format();
  const to = moment(date).add(1, 'days').format();

  const params = moment(date).isSame(new Date(), 'days') ? undefined : { from, to };

  return createWebhooksApi(true)
    .then((api) => api.get<any>(`/${subscriberId}/logs`, params))
    .then((r) => (r.ok ? r.data.data : null));
}

export function fetchWebhookLog(subscriberId: string, logId: string): Promise<LogWithData> {
  return createWebhooksApi(true)
    .then((api) => api.get<any>(`/${subscriberId}/logs`, { id: logId }))
    .then((r) => (r.ok ? r.data.data : null));
}

export function replayWebhook(subscriberId: string, logId: string): Promise<boolean> {
  return createWebhooksApi()
    .then((api) => api.post<any>(`/${subscriberId}/replay?id=${logId}`))
    .then((r) => r.ok);
}
